/**
 * Image Accordion Block JS
 *
 * @since 1.1.0
 */

(() => {
	// Grab all possible accordions
	const accordions = document.querySelectorAll('.as-block-image-accordion');

	// No accordions? Stop here
	if (!accordions) {
		return;
	}

	// Loop em
	accordions.forEach((accordion) => {
		// Grab all the image accordion items
		const imageAccordionItems = accordion.querySelectorAll('.as-image-accoridon-item');

		// Grab all the images too
		const images = accordion.querySelectorAll('.as-image-accoridon-image');

		// None? Stop here
		if (!imageAccordionItems || !images) {
			return;
		}

		// Loop through each item
		imageAccordionItems.forEach((item) => {
			// Grab the "link" and watch for clicks
			const link = item.querySelector('a');

			// None? Stop here
			if (!link) {
				return;
			}

			// Watch for clicks
			link.addEventListener('click', (e) => {
				// Prevent the default action
				e.preventDefault();

				// Grab the data-target attribute
				const target = link.getAttribute('data-target');

				// No target? Stop here
				if (!target) {
					return;
				}

				// Grab the target element (the image)
				const image = document.getElementById(target);

				// No image? Stop here
				if (!image) {
					return;
				}

				// Now lets remove the open class from the other items
				imageAccordionItems.forEach((item) => {
					item.classList.remove('open');
				});

				images.forEach((image) => {
					image.classList.remove('open');
				});

				// Add the open class to the clicked item
				item.classList.add('open');

				// Add the open class to the image
				image.classList.add('open');
			});
		});
	});
})();